import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IOrderShipped } from "@/interfaces/order-status.interfaces";
import orderStatusService from "@/services/order-status.service";
import { RequestsProps } from "@/types/requests.types";

export type ShipOrderProps = {
  formData: IOrderShipped;
} & RequestsProps;

export type UseShipOrderReturn = {
  create: (props: ShipOrderProps) => Promise<void>;
} & UseLoadingReturn;

const useShipOrder = (): UseShipOrderReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IOrderShipped>({
    operation: (formData) => orderStatusService.ship(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useShipOrder;
